import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpLink } from 'foundations-components/transitional/components/HelpLink';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { H5 } from 'foundations-components/transitional/components/H5';
import { List } from 'foundations-components/transitional/components/List';
import { useBoardPanelPresentationContext } from '../context/BoardPanelPresentationContext';

// Currently only available for Deals and Tickets
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const NextLastActivityCardPreferences = ({
  isDealObjectType
}) => {
  const {
    settings,
    updateDraft
  } = useBoardPanelPresentationContext();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: isDealObjectType ? 'editCardsPanel.nextLastActivitySection.header.deals' : 'editCardsPanel.nextLastActivitySection.header.tickets',
        useGap: true
      })
    }), /*#__PURE__*/_jsx(MultiColumn, {
      flush: true,
      children: /*#__PURE__*/_jsxs(MultiColumnGroup, {
        children: [/*#__PURE__*/_jsxs(MultiColumnItem, {
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: isDealObjectType ? 'editCardsPanel.nextLastActivitySection.toggle.description.deals' : 'editCardsPanel.nextLastActivitySection.toggle.description.tickets',
              useGap: true
            })
          }), /*#__PURE__*/_jsx(HelpLink, {
            showCloseButton: true,
            placement: "left",
            content: {
              header: /*#__PURE__*/_jsx(H5, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: isDealObjectType ? 'editCardsPanel.nextLastActivitySection.helpLinkDescriptionHeader.deals' : 'editCardsPanel.nextLastActivitySection.helpLinkDescriptionHeader.tickets'
                })
              }),
              body: /*#__PURE__*/_jsxs(List, {
                styled: true,
                wrapChildren: true,
                children: [/*#__PURE__*/_jsx("span", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "editCardsPanel.nextLastActivitySection.notes"
                  })
                }), /*#__PURE__*/_jsx("span", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "editCardsPanel.nextLastActivitySection.calls"
                  })
                }), /*#__PURE__*/_jsx("span", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "editCardsPanel.nextLastActivitySection.trackedSalesEmails"
                  })
                }), /*#__PURE__*/_jsx("span", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "editCardsPanel.nextLastActivitySection.meetings"
                  })
                }), /*#__PURE__*/_jsx("span", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "editCardsPanel.nextLastActivitySection.tasks"
                  })
                }), /*#__PURE__*/_jsx("span", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "editCardsPanel.nextLastActivitySection.chats"
                  })
                })]
              })
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: isDealObjectType ? 'editCardsPanel.nextLastActivitySection.helpLinkText.deals' : 'editCardsPanel.nextLastActivitySection.helpLinkText.tickets',
              useGap: true
            })
          })]
        }), /*#__PURE__*/_jsx(MultiColumnItem, {
          children: /*#__PURE__*/_jsx(Toggle, {
            "data-test-id": "next-last-activity-toggle",
            "data-selenium-checked": !settings.nextLastActivityPreferences.isTurnedOff,
            size: "small",
            checked: !settings.nextLastActivityPreferences.isTurnedOff,
            onChange: () => {
              updateDraft({
                nextLastActivityPreferences: Object.assign({}, settings.nextLastActivityPreferences, {
                  isTurnedOff: !settings.nextLastActivityPreferences.isTurnedOff
                })
              });
            }
          })
        })]
      })
    })]
  });
};